import React from 'react'

class AboutNl extends React.Component {
  render() {
    return <div>
      <h2>Over de databank</h2>

      <p><strong>De databank SenLex</strong><strong> verzamelt officiële informatie over de Belgische institutionele regelgeving. &nbsp;U vindt in deze databank, voor elk artikel van de belangrijkste institutionele normen, de relevante fragmenten uit de parlementaire stukken, de rechtspraak van het Grondwettelijk Hof en de adviezen van de Raad van State. </strong></p>

      <p>De Belgische institutionele regelgeving omvat <strong>de Grondwet, de bijzondere meerderheidswetten en enkele gewone wetten</strong>.&nbsp;</p>

      <p>Wie de precieze draagwijdte van die regelgeving wenst te kennen, heeft echter zelden voldoende aan de wettekst alleen.&nbsp; De inhoud van de institutionele wetteksten wordt in ruime mate bepaald door de parlementaire voorbereiding ervan, door de arresten van het Grondwettelijk Hof en door de adviezen en arresten van de Raad van State.&nbsp; Er is bijzonder veel officiële informatie over de institutionele regelgeving beschikbaar.&nbsp; Die informatie is echter zeer verspreid en weinig overzichtelijk. &nbsp;Senlex brengt die officiële informatie uit <strong>de parlementaire voorbereiding, de arresten van het Grondwettelijk Hof en de adviezen en arresten van de Raad van State</strong> samen.&nbsp;</p>

      <p>De gegevens worden gestructureerd per artikel of, indien nuttig, per onderdeel van een artikel.&nbsp; Per artikel wordt de informatie ingedeeld in de volgende rubrieken:</p>

      <ul>
        <li>de wettekst</li>
        <li>trefwoorden</li>
        <li>annotaties:
          <ul>
            <li>wetshistoriek</li>
            <li>parlementaire voorbereiding</li>
            <li>rechtspraak en adviezen</li>
            <li>toelichting</li>
            <li>verwijzingen naar andere artikelen.</li>
          </ul>
        </li>
      </ul>

      <p>In de rubrieken “parlementaire voorbereiding” en “rechtspraak en adviezen” vindt u niet alleen <strong><em>hyperlinks</em></strong> naar de betrokken documenten, maar worden de relevante fragmenten uit die documenten bovendien <strong>integraal</strong> opgenomen.&nbsp; U hoeft in de documenten dus niet zelf op zoek te gaan naar de tekstgedeelten die het artikel in kwestie betreffen, Senlex biedt die fragmenten zelf <em>in extenso</em> aan.</p>

      <p>Via de <a href="/nl">homepagina</a> heeft u rechtstreeks toegang tot de verschillende geannoteerde teksten of kan u met de zoekfunctie, aan de hand van trefwoorden of vrije zoektermen, opzoekingen doen.</p>

      <p>Senlex verzamelt de officiële informatie die werd gepubliceerd <strong>sinds 1 juli 2014</strong>.&nbsp; Senlex bevat evenwel ook de integrale parlementaire voorbereiding van de Zesde Staatshervorming, die reeds vóór die datum werd gepubliceerd.&nbsp; Uitzonderlijk zijn ook oudere teksten terug te vinden.&nbsp;</p>

      <p>De databank Senlex wordt samengesteld door de diensten van de Senaat.&nbsp; De databank heeft een louter informatieve waarde. Aan het samenstellen ervan wordt de grootste zorg besteed, maar noch de Senaat noch de diensten kunnen aansprakelijk worden gesteld voor de inhoud ervan.&nbsp; U vindt hierover meer informatie in de <a href="/nl/disclaimer">disclaimer</a>.</p>
    </div>
  }
}

export default AboutNl;





/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/about/nl.js
 **/